<template lang="html">
  <article class="locationItem" @click="$emit('handleClick', image, index)">
    <div class="locationItem__image" :style="{backgroundImage: `url(${image})`}"></div>
    <h3 class="locationItem__label">{{label}}</h3>
  </article>
</template>

<script>
export default {
  name: 'LocationItem',
  props: ['image', 'label','index']
}
</script>

<style lang="scss">
@import "../styles/config.scss";
  .locationItem {
    &:after {
      content: 'expand';
      font-family: CamptonBold;
      color: var(--Neu01);
      position: absolute;
      top: 10px;
      left: 50%;
      transform: translateX(-50%) scale(.5);
      border: 1px solid var(--M01);
      border-radius: 50%;
      padding: 80px 65px;
      pointer-events: none;
      opacity: 0;
      transition: all .3s cubic-bezier(.41,.15,.41,1.31);
    }
    &:hover {
      &:after {
        opacity: 1;
        transform: translateX(-50%) scale(1);
      }
    }
    &__image {
      height: 200px;
      max-width: 360px;
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
      overflow: hidden;
      &:after {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: block;
        background-color: rgba(0,0,0,.3);
      }
    }
    &__label {
      font-family: CamptonBold;
      font-size: 16px;
      color: var(--Neu01);
      margin-top: 20px;
      margin-bottom: 5px;
    }
    @include mq(0,1024px) {
      &:after {
        padding: 60px 55px;
      }
      &__label {
        margin-top: 10px;
        margin-bottom: 5px;
      }
    }
    // TODO: VER ISTO
    @include mq(0,768px) {
      &:after {
        padding: 60px 55px;
      }
    }
    @include mq(0,768px) {
      &:after {
        top: 15px;
        padding: 70px 65px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/LocationItem.vue